if (!customElements.get('lookbook-icon')) {
  customElements.define(
    'lookbook-icon',
    class LookbookIcon extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          cardContainer: '.lookbook-card',
          cardProduct: '.lookbook-card__product',
        };

        this.cardContainer = this.closest(this.selectors.cardContainer);
        this.cardProduct = this.querySelector(this.selectors.cardProduct);

        this._boundInit = this.init.bind(this);
        this._boundToggle = this.handleToggle.bind(this);
        this._boundOutside = this.handleOutsideClick.bind(this);

        this.init();
        this.addEventListener('mouseover', this._boundInit);
        this.addEventListener('click', this._boundToggle);
      }

      disconnectedCallback() {
        this.removeEventListener('mouseover', this._boundInit);
        this.removeEventListener('click', this._boundToggle);
        document.removeEventListener('touchstart', this._boundOutside);
      }

      handleToggle(e) {
        e.stopPropagation();

        // Sur desktop, le hover suffit — on ne toggle pas au clic
        if (window.matchMedia('(hover: hover)').matches) return;

        this.init();

        const isOpen = this.cardProduct.classList.contains('is-active');

        // Fermer tous les autres lookbook-icons ouverts
        this.cardContainer
          .querySelectorAll('lookbook-icon .lookbook-card__product.is-active')
          .forEach((el) => el.classList.remove('is-active'));

        if (!isOpen) {
          this.cardProduct.classList.add('is-active');
          // Fermer si on touche ailleurs
          document.addEventListener('touchstart', this._boundOutside, { once: true });
        }
      }

      handleOutsideClick(e) {
        if (!this.contains(e.target)) {
          this.cardProduct.classList.remove('is-active');
        }
      }

      init() {
        if (this.cardProduct) {
          this.cardContainerOffsetX = this.cardContainer.getBoundingClientRect().left;
          this.cardContainerOffsetY = this.cardContainer.getBoundingClientRect().top;

          this.offsetX = this.getBoundingClientRect().left - this.cardContainerOffsetX;
          this.offsetY = this.getBoundingClientRect().top - this.cardContainerOffsetY;

          this.cardProductWidth = this.cardProduct.clientWidth;
          this.cardProductHeight = this.cardProduct.clientHeight;
          this.cardContainerWidth = this.cardContainer.clientWidth;

          if (this.offsetX > this.cardProductWidth) {
            this.cardProduct.style.left = 'auto';
            if (this.cardContainerWidth - this.offsetY < 15) {
              this.cardProduct.style.right = 'calc(-100% + 2rem)';
            } else {
              this.cardProduct.style.right = '-100%';
            }
          } else {
            this.cardProduct.style.right = 'auto';
            if (this.cardContainerWidth - this.offsetX > this.cardProductWidth) {
              if (this.offsetX < 15) {
                this.cardProduct.style.left = 'calc(-100% + 2rem)';
              } else {
                this.cardProduct.style.left = '-100%';
              }
            } else {
              this.cardProduct.style.left =
                this.cardContainerWidth - this.cardProductWidth - this.offsetX + 'px';
            }
          }

          if (this.offsetY > this.cardProductHeight) {
            this.cardProduct.style.top = 'auto';
            this.cardProduct.style.bottom = '100%';
          } else {
            this.cardProduct.style.bottom = 'auto';
            this.cardProduct.style.top = '100%';
          }
        }
      }
    }
  );
}